import React from 'react';
import { meta, heroStats } from '../data/caseStudy';
const factRows = [{
  label: 'Client',
  value: meta.client
}, {
  label: 'Role',
  value: meta.role
}, {
  label: 'Timeline',
  value: meta.timeline
}, {
  label: 'Services',
  value: meta.services
}];
export function Hero() {
  return <header id="hero" className="w-full bg-ink text-white" data-id="element-49" data-mp="4lywep65kkf8">
      <div className="mx-auto w-[1200px] px-24 pb-24 pt-24" data-id="element-50" data-mp="4njng4t9dl8c">
        <div className="flex items-center justify-between" data-id="element-51" data-mp="128fqlljlahwr">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.32em] text-white/60" data-id="element-52" data-mp="xae7j0m5yila">
            CREATEFUTURE CASE STUDY / DESIGN LEADERSHIP
          </p>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.32em] text-white/40" data-id="element-53" data-mp="s9gj46ak8sbc">
            Nektaria Bogris
          </p>
        </div>

        <div className="mt-10 h-[3px] w-full accent-rule" aria-hidden="true" data-id="element-54" data-mp="3d1s9sv56tfs2" />

        <h1 className="mt-14 max-w-[900px] font-display text-[86px] font-bold leading-[0.92] tracking-tightest" style={{
        fontWeight: "600"
      }} data-id="element-55" data-mp="382p91mw8pvpw">
          Building a unified{' '}
          <span className="accent-text" data-id="element-56" data-mp="3o7c1q2dl4xiq">design culture</span> for CreateFuture
        </h1>

        <p className="mt-10 max-w-[720px] text-xl leading-relaxed text-white/70" data-id="element-57" data-mp="39acw2k2aneqw">{meta.subtitle}</p>

        <div className="mt-16 overflow-hidden border border-white/10" data-id="element-58" data-mp="3e9fqzbok84l5">
          <img src="https://cdn.magicpatterns.com/uploads/oxKQnCpxX1mZaJqXExUDgY/5.png" alt="CreateFuture brand identity, wordmark set against the new gradient visual language" className="h-[300px] w-full object-cover" data-id="element-59" data-mp="3e7l8s54oaqkr" />
        </div>

        <dl className="mt-16 grid grid-cols-4 gap-8 border-t border-white/15 pt-10" data-id="element-60" data-mp="2qk3mgp46gkp6">
          {factRows.map(row => <div key={row.label} data-id="element-61" data-mp="2vietyt702j48">
              <dt className="font-display text-[11px] font-semibold uppercase tracking-[0.22em] text-white/45" data-id="element-62" data-mp="2vjpvsngvxgsp">
                {row.label}
              </dt>
              <dd className="mt-3 text-[15px] leading-snug text-white/90" data-id="element-63" data-mp="2lkij82hz5q6n">{row.value}</dd>
            </div>)}
        </dl>

        <div className="mt-20 grid grid-cols-4 gap-x-10 gap-y-12 border-t border-white/15 pt-14" data-id="element-64" data-mp="s335tfryasyl">
          {heroStats.map(stat => <div key={stat.label} data-id="element-65" data-mp="n9qj5b6u0w8h">
              <p className="font-display text-[68px] font-bold leading-none tracking-tightest accent-text" data-id="element-66" data-mp="ic86b9pp1wv7">
                {stat.value}
              </p>
              <p className="mt-5 text-sm leading-snug text-white/70" data-id="element-67" data-mp="degd8cdbc4pf">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </header>;
}